import { Component, OnInit } from '@angular/core';
import { StreamreportService } from '../../service/streamreport.service';

@Component({
  selector: 'app-stream-report',
  standalone: false,
  templateUrl: './stream-report.component.html',
  styleUrl: './stream-report.component.scss'
})
export class StreamReportComponent implements OnInit {

  reports: any[] = []
  constructor(
    private streamReportService: StreamreportService,
  ) { }

  async ngOnInit() {
    let data = await this.streamReportService.getStreamReports(null);
    if (data === false) return;
    // console.log(data);

    for await (let re of data) {
      let exists = await this.reports.find((ra: any) => ra.userId == re.userId && ra.roundId == re.roundId);
      if (!exists) {
        this.reports.push({
          userId: re.userId,
          roundId: re.roundId,
          sessionId: re.sessionId,
          username: re.username,
          email: re.email,
          reportData: [{
            'date': re.date,
            'time': re.time,
            'llmId': re.llmId,
            'finalPrompt': re.finalPrompt,
            'promptResult': re.promptResult,
            'buttonName': re.buttonName,
          }]
        });

      } else {
        for (let report of this.reports) {
          if (report.userId == re.userId && report.roundId == re.roundId) {
            report.reportData.push({
              'date': re.date,
              'time': re.time,
              'llmId': re.llmId,
              'finalPrompt': re.finalPrompt,
              'promptResult': re.promptResult,
              'buttonName': re.buttonName,
            })
          }
        }
      }

    }
    console.log('Reports', this.reports);

  }

}
